import { observable, action } from "mobx";
import { StorageService } from "../storage";
import {
  AvailablePermissions,
  PermissionStatus,
} from "./permissions.interface";
import { ServiceInterface } from "../service.interface";
import { createContext } from "react";
import { PermissionAdapterInterface } from "./permission-adapter.interface";

const KEY_DID_REQUEST_NOTIFICATIONS = "KEY_DID_REQUEST_NOTIFICATIONS";

export const PermissionServiceContext = createContext<PermissionService>(
  null as any
);

export class PermissionService implements ServiceInterface {
  public context = PermissionServiceContext;

  constructor(
    private storageService: StorageService,
    private permissionAdapter: PermissionAdapterInterface
  ) {}

  public didRequestNotifications = this.storageService.getPreference(
    KEY_DID_REQUEST_NOTIFICATIONS,
    false
  );

  public async serviceWillMount() {
    await this.didRequestNotifications.ready$;
    await this.checkPermissions();
  }

  public serviceDidBecomeForeground() {
    this.checkPermissions();
  }

  @observable
  public camera: PermissionStatus | undefined;

  @observable
  public location: PermissionStatus | undefined;

  @observable
  public notification: PermissionStatus | undefined;

  @action
  public setPermission(perm: AvailablePermissions, status: PermissionStatus) {
    this[perm] = status;
  }

  private checkPermissions() {
    return Promise.all([
      this.permissionAdapter.checkPermission("camera").then((response) => {
        this.setPermission("camera", response);
      }),
      this.permissionAdapter.checkPermission("location").then((response) => {
        this.setPermission("location", response);
      }),
      this.permissionAdapter
        .checkPermission("notification")
        .then((response) => {
          this.setPermission("notification", response);
        }),
    ]);
  }

  public requestPermission = async (permission: AvailablePermissions) => {
    const status = await this.permissionAdapter.requestPermission(permission);
    if (permission === "notification")
      this.didRequestNotifications.setValue(true);
    this.setPermission(permission, status);
    return status;
  };
}
